import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ListCellDefDirective,
  ListModuleColumnDef,
  ListModuleTableComponent,
} from 'src/app/shared/components/list-module';
import { IconModule } from 'src/app/shared/icon/icon.module';
import { AppDatePipe } from 'src/app/shared/pipes/app-date.pipe';
import { PlatformNotificationItem } from 'src/app/core/services/platform-notification.service';

export type NotificationRow = PlatformNotificationItem & { srNo: number };

@Component({
  selector: 'app-notifications-table',
  standalone: true,
  imports: [
    CommonModule,
    IconModule,
    AppDatePipe,
    ListModuleTableComponent,
    ListCellDefDirective,
  ],
  templateUrl: './notifications-table.component.html',
})
export class NotificationsTableComponent {
  @Input() rows: NotificationRow[] = [];
  @Input() loading = false;
  @Input() emptyMessage = 'No notifications match your filters.';

  @Output() markRead = new EventEmitter<{ row: NotificationRow; event: Event }>();
  @Output() open = new EventEmitter<NotificationRow>();

  get columns(): ListModuleColumnDef[] {
    return [
      { id: 'serial', header: '#', cellClass: 'whitespace-nowrap text-gray-500' },
      { id: 'type', header: 'Type', cellClass: 'whitespace-nowrap' },
      { id: 'title', header: 'Title', cellClass: 'font-semibold' },
      { id: 'message', header: 'Message' },
      { id: 'status', header: 'Status', align: 'center', cellClass: 'whitespace-nowrap text-center' },
      { id: 'date', header: 'Date', cellClass: 'whitespace-nowrap text-sm text-gray-500' },
      // { id: 'actions', header: 'Action', align: 'right', cellClass: 'text-end' },
    ];
  }
}
